/** Default and per-section SEO copy for 12K (slots, fishing, Shan Koe Mee, Bugyi, live casino, card games). */

/** Protocol + host (no trailing slash). Uses the live URL so one build works on 12K.biz, .cc, .tel, etc. */
export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Absolute canonical URL for a route pathname (must match router SEO / index.html bootstrap).
 * @param {string} [path] pathname e.g. /home (query/hash ignored)
 */
export function getCanonicalUrlForPath(path) {
  const pathname = ((path || '/').split('?')[0] || '/').replace(/\/+$/, '') || '/';
  const origin = getSiteOrigin();
  if (!origin) return '';
  return pathname === '/' ? origin : `${origin}${pathname}`;
}

const BASE_DESC =
  '12K offers 2D/3D lottery, football betting, online slots, fishing games, Shan Koe Mee, Bugyi, card games and live casino. Play securely with fast deposits and withdrawals for Myanmar players.';

const BASE_KEYWORDS =
  '12K, 2D lottery, 3D lottery, football betting, body football, maung, online slots, fishing game, Shan Koe Mee, Bugyi, live casino, Myanmar lottery, Myanmar football';

export const siteDefaults = {
  title: '12K | Lottery, Football, Slots, Fishing & Live Casino',
  description: BASE_DESC,
  keywords: BASE_KEYWORDS,
};

export const pageMeta = {
  home: siteDefaults,

  slots: {
    title: 'Online Slot Games | 12K — Jackpots & Popular Slots',
    description:
      'Play hundreds of online slot games at 12K: classic reels, video slots, jackpots and bonus features. Fast play, fair results, mobile-friendly.',
    keywords: `${BASE_KEYWORDS}, video slots, jackpot slots, slot bonus`,
  },

  fishing: {
    title: 'Fishing Arcade Games Online | 12K',
    description:
      'Shoot-and-catch fishing arcade games at 12K. Colorful tables, multipliers and real-time action—popular in Myanmar and Southeast Asia.',
    keywords: `${BASE_KEYWORDS}, fishing shooter game, arcade fishing`,
  },

  liveCasino: {
    title: 'Live Casino & Live Dealer Games | 12K',
    description:
      'Live casino at 12K: real dealers, HD streams, baccarat, roulette and more. Feel like a real casino floor from your phone or desktop.',
    keywords: `${BASE_KEYWORDS}, live baccarat, live roulette, HD casino stream`,
  },

  shanKoeMee: {
    title: 'Shan Koe Mee Online Rooms | 12K',
    description:
      'Join Shan Koe Mee (Shan poker) tables at 12K. Play with friends or match online—authentic card rules and smooth gameplay.',
    keywords: `${BASE_KEYWORDS}, Shan Koe Mee room, Shan poker online`,
  },

  bugyee: {
    title: 'Bugyi (Bugyee) Card Game Online | 12K',
    description:
      'Play Bugyi / Bugyee card games online at 12K. Traditional Myanmar-style card play with reliable tables and quick rounds.',
    keywords: `${BASE_KEYWORDS}, Bugyi online, Bugyee card game`,
  },

  cardGames: {
    title: 'Online Card Games & Tables | 12K',
    description:
      'Card games and table games at 12K alongside slots and live casino. One account for multiple game types.',
    keywords: `${BASE_KEYWORDS}, table games, multiplayer cards`,
  },

  arcade: {
    title: 'Arcade & Casual Games | 12K',
    description: 'Arcade and casual games at 12K—quick fun between slots, fishing and live casino sessions.',
    keywords: `${BASE_KEYWORDS}, arcade games online`,
  },

  promotion: {
    title: 'Casino Promotions & Bonuses | 12K',
    description:
      'Latest 12K promotions: welcome offers, reload bonuses and cashback for slots, live casino and card games. Check terms on each offer.',
    keywords: `${BASE_KEYWORDS}, casino bonus, welcome bonus, cashback`,
  },

  login: {
    title: 'Member Login | 12K',
    description: 'Log in to your 12K account to play slots, fishing, Shan Koe Mee, Bugyi, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, 12K login`,
  },

  register: {
    title: 'Register & Join | 12K',
    description:
      'Create a 12K account in minutes. Access slots, fishing games, Shan Koe Mee, Bugyi, live casino and secure banking.',
    keywords: `${BASE_KEYWORDS}, 12K register, sign up`,
  },

  contact: {
    title: 'Contact Us | 12K',
    description: 'Contact 12K support for account, deposits, withdrawals and game questions.',
    keywords: `${BASE_KEYWORDS}, 12K support, customer service`,
  },

  rule: {
    title: 'Rules & Terms | 12K',
    description: 'Rules, terms and responsible play information for 12K members.',
    keywords: `${BASE_KEYWORDS}, terms and conditions`,
  },

  deposit: {
    title: 'Deposit | 12K',
    description: 'Deposit funds securely to play slots, fishing, live casino and card games at 12K.',
    keywords: `${BASE_KEYWORDS}, deposit`,
    robots: 'noindex, nofollow',
  },

  withdraw: {
    title: 'Withdraw | 12K',
    description: 'Withdraw your winnings from 12K with supported payment methods.',
    keywords: `${BASE_KEYWORDS}, withdraw`,
    robots: 'noindex, nofollow',
  },

  banking: {
    title: 'Banking | 12K',
    description: 'Banking and payment options for 12K members.',
    keywords: `${BASE_KEYWORDS}, banking`,
    robots: 'noindex, nofollow',
  },

  history: {
    title: 'Transaction History | 12K',
    description: 'View your 12K transaction history.',
    robots: 'noindex, nofollow',
  },

  setting: {
    title: 'Account Settings | 12K',
    description: 'Manage your 12K account settings.',
    robots: 'noindex, nofollow',
  },

  betslip: {
    title: 'Betslip History | 12K',
    description: 'Your betslip history at 12K.',
    robots: 'noindex, nofollow',
  },

  liveScore: {
    title: 'Live Score | 12K',
    description: 'Live scores and sports updates at 12K.',
    keywords: BASE_KEYWORDS,
  },

  matchResult: {
    title: 'Football Match Results | 12K',
    description: 'View today and yesterday football match results at 12K.',
    keywords: `${BASE_KEYWORDS}, football results, match results`,
  },

  maungFb: {
    title: 'Maung FB | 12K',
    description: 'Maung FB at 12K.',
    keywords: BASE_KEYWORDS,
  },

  bodyFb: {
    title: 'Body FB | 12K',
    description: 'Body FB at 12K.',
    keywords: BASE_KEYWORDS,
  },

  videoLinks: {
    title: 'Video Links | 12K',
    description: 'Video links and guides at 12K.',
    keywords: BASE_KEYWORDS,
  },

  commission: {
    title: 'Commission | 12K',
    description: 'Commission program at 12K.',
    robots: 'noindex, nofollow',
  },

  level: {
    title: 'VIP Levels | 12K',
    description: 'VIP levels and rewards at 12K.',
    keywords: `${BASE_KEYWORDS}, VIP`,
  },

  guides: {
    title: 'App Install Guide | 12K',
    description: 'Install the 12K app on Android or iOS for slots, fishing, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, 12K app, install guide`,
  },

  androidGuide: {
    title: 'Android App Install | 12K — Slots, Fishing & Live Casino',
    description:
      'Install 12K on Android: play online slots, fishing games, Shan Koe Mee, Bugyi and live casino on your phone.',
    keywords: `${BASE_KEYWORDS}, 12K Android APK`,
  },

  iosGuide: {
    title: 'iOS App Install | 12K — Slots, Fishing & Live Casino',
    description:
      'Install 12K on iPhone or iPad: slots, fishing arcade, card games and live dealer casino.',
    keywords: `${BASE_KEYWORDS}, 12K iOS app`,
  },

  dreamBooks: {
    title: 'Dream Books | 12K',
    description: 'Dream books feature at 12K.',
    keywords: BASE_KEYWORDS,
  },

  twoD: {
    title: '2D | 12K',
    description: '2D games at 12K.',
    keywords: BASE_KEYWORDS,
  },

  threeD: {
    title: '3D | 12K',
    description: '3D games at 12K.',
    keywords: BASE_KEYWORDS,
  },

  landing: {
    title: '12K — Slots, Fishing, Live Casino & Card Games',
    description: BASE_DESC,
    keywords: BASE_KEYWORDS,
  },

  iframe: {
    title: 'Game | 12K',
    robots: 'noindex, nofollow',
  },

  verify: {
    title: 'Verify Account | 12K',
    robots: 'noindex, nofollow',
  },

  dataTable: {
    title: 'Data | 12K',
    robots: 'noindex, nofollow',
  },
};
